<template>
  <div v-if="show && loaded">
<!--    皮肤测试入口屏蔽-->
<!--    <div class="skinTest" v-if="skinInfo.orderid">-->
<!--      <img @click="close" src="../../assets/images/close1.png">-->
<!--      <img :src="skinInfo.ndoresultimg ? skinInfo.ndoresultimg : '/static/images/skintest4.png'" @click="handleSkinResult" data-growing-title="皮肤测试">-->
<!--      <div class="skindesc" @click="handleSkinResult">{{skinInfo.skin_type}}</div>-->
<!--    </div>-->
<!--    <div class="skinTest" v-else>-->
<!--      <img @click="close" src="../../assets/images/close1.png">-->
<!--      <img :src="skinInfo.ndoimg ? skinInfo.ndoimg : '/static/images/skintest3.png'" @click="goSkin">-->
<!--      <span @click="goSkin"></span>-->
<!--    </div>-->
  </div>
</template>

<script>
import { isWeixin } from '../../assets/common/js/config'

export default {
  name: 'skinTest',
  data () {
    return {
      show: true,
      skinInfo: {},
      loaded: false
    }
  },
  props: {
    page: {
      type: String,
      default: ''
    }
  },
  mounted () {
    // 皮肤测试入口屏蔽
    // 登录校验
    // if (!isWeixin()) {
    //   if (this.waptoken.waptoken && this.waptoken.waptoken != this.waptoken.tourists) {
    //     let url = this.$ajax.getNdoResult_URL
    //     this.$customRequestAjax(url).then(res => {
    //       if (res.data.code === 200) {
    //         this.skinInfo = res.data
    //         this.loaded = true
    //       }
    //     })
    //   }
    // } else {
    //   let url = this.$ajax.getNdoResult_URL
    //   this.$customRequestAjax(url).then(res => {
    //     if (res.data.code === 200) {
    //       this.skinInfo = res.data
    //       this.loaded = true
    //     }
    //   })
    // }
  },
  methods: {
    close: function () {
      var that = this
      that.$dialog.confirm({
        title: '关闭后将不再显示',
        message: '关闭后可前往“我的”点击头像查看',
        className: 'collect_button_alert collect_button_skin',
        cancelButtonColor: '#FC0324',
        confirmButtonColor: '#FFFCFC'
      }).then(() => {
        // on confirm
        if (that.page == 'home') {
          that.$store.commit('SKIN_TEXT_HOME_SHOW', 0)
          that.show = false
        } else if (that.page == 'cart') {
          that.$store.commit('SKIN_TEXT_CART_SHOW', 0)
          that.show = false
        } else if (that.page == 'category') {
          that.$store.commit('SKIN_TEXT_CATEGORY_SHOW', 0)
          that.show = false
        } else if (that.page == 'productcategory') {
          that.$store.commit('SKIN_TEXT_PRODUCT_CATEGORY_SHOW', 0)
          that.show = false
        } else if (that.page == 'search') {
          that.$store.commit('SKIN_TEXT_SEARCH_SHOW', 0)
          that.show = false
        }
      }).catch(() => {
        // on cancel
      })
    },
    handleSkinResult: function () {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'skin'
        },
        callback: () => {
          this.$router.push({
            path: '/analysisDetail',
            query: {
              orderid: this.skinInfo.orderid,
              sex: this.skinInfo.sex,
              source: 'records'
            }
          })
        }
      })
    },
    goSkin: function () {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'skin'
        },
        callback: () => {
          this.$router.push('/skinAnalysis')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .skinTest {
    width: 100%;
    position: relative;
    padding: 0 0.11rem 0;
    /*margin-bottom: 0.1rem;*/
    img:nth-of-type(1) {
      width: 0.15rem;
      height: 0.15rem;
      position: absolute;
      right: 0.12rem;
    }
    img:nth-of-type(2) {
      width: 100%;
    }
    span {
      width: .55rem;
      height: .55rem;
      display: block;
      position: absolute;
      right: .18rem;
      bottom: .09rem;
    }
    .skindesc {
      font-size: .11rem;
      line-height: .17rem;
      position: absolute;
      top: 0.32rem;
      right: 0.3rem;
      width: 2rem;
      height: 0.51rem;
      color: #4B3E32;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }
</style>
<style lang="scss">
  .collect_button_skin {
    .van-dialog__content {
      padding-top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/skinTest.vue